import Link from "next/link";
import * as Props from "../../types/PropTypes";
import styles from "./HowToPlay.module.scss";
import Image from "next/image";

export const HowToPlayWrapper: React.FC<Props.Base> = ({ children }) => (
  <div className={styles.howToPlayWrapper}>{children}</div>
);

export const MainContentWrapper: React.FC<Props.Base> = ({ children }) => (
  <div className={styles.mainContentWrapper}>{children}</div>
);

export const ContentWrapper: React.FC<Props.Base> = ({ children }) => (
  <div className={styles.contentWrapper}>{children}</div>
);

export const SideBarWrapper: React.FC<Props.Base> = ({ children }) => (
  <div className={styles.sideBarWrapper}>{children}</div>
);

export const StyledLinkSudoku: React.FC<Props.SudokuMainLink> = ({ name, href }) => (
  <Link href={href} className={styles.playSudokuLink}>
    {name}
  </Link>
);

export const SudokuBanner: React.FC<Props.Base> = ({ children }) => (
  <div className={styles.sudokuBannerBox}>
    <Image
      src="/images/sudoku-banner.webp"
      alt="Banner for how to play Sudoku"
      className={styles.sudokuPreviewImg}
      width={850}
      height={440}
    />
    {children}
  </div>
);

export const SideBarStyledLinkSudoku: React.FC<Props.SudokuMainLink> = ({ name, href }) => (
  <Link href={href} className={styles.sideBarStyledLinkSudoku}>
    {name}
  </Link>
);

export const SideBarSudokuBanner: React.FC<Props.Base> = ({ children }) => (
  <div className={styles.sideBarSudokuBannerBox}>
    <Image
      src="/images/play-sudoku-online.webp"
      alt="Banner for how to play Sudoku"
      className={styles.sudokuPreviewSideBarImg}
      width={410}
      height={205}
    />
    {children}
  </div>
);
